import React from 'react';

import { Section, preloader } from 'spectacle-ppa';
import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import apprenticesPosing from '../../images/characters/apprenticesPosing.png';
import apprenticesFlexArms from '../../images/characters/apprenticesFlexArms.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './song.md';

const md = new MarkdownScript(markdownFile);

export function preloadSong () {
  preloader([
    apprenticesPosing,
    apprenticesFlexArms
  ]);
}

function songSection ({ level, regionData }) {
  return (
    <Section id="song">

      {/* Intro to song in Level 1 */}
      { (level === 1) &&
        videoSlide({
          id: 'intro-video',
          notes: md.getSubSectionAsHtml(`Level ${level} Intro`, 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata(`Level ${level} Intro`, 'YouTube', regionData)
        })
      }

      {/* Welcome back by Ian in levels 2,4,6 */}
      { (level === 2 || level === 4 || level === 6) &&
        balloonSlide({
          id: 'welcome-back',
          characterSide: 'right',
          characterImage: apprenticesPosing,
          html: md.getSubSectionAsHtml(`Level ${level} Intro`, 'Content', false, regionData),
          notes: md.getSubSectionAsHtml(`Level ${level} Intro`, 'Notes', false, regionData)
        })
      }

      {/* Welcome back by Sara in levels 3 */}
      { (level === 3) &&
        balloonSlide({
          id: 'welcome-back',
          characterSide: 'right',
          characterImage: apprenticesFlexArms,
          html: md.getSubSectionAsHtml(`Level ${level} Intro`, 'Content', false, regionData),
          notes: md.getSubSectionAsHtml(`Level ${level} Intro`, 'Notes', false, regionData)
        })
      }

      {/* Song */}
      {videoSlide({
        id: 'video',
        notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData)
      })}

    </Section>
  );
}

export default songSection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/03_song/songSection.jsx